import { render, staticRenderFns } from "./ModalTabelaProfissional.vue?vue&type=template&id=345aaf95"
import script from "./ModalTabelaProfissional.vue?vue&type=script&lang=ts"
export * from "./ModalTabelaProfissional.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports